// extracted by mini-css-extract-plugin
module.exports = {"trackerTooltip":"w1mNc"};